import styled from 'styled-components';
import { transparentize, lighten, darken } from 'polished';

import { Table as GlobalTable } from 'styles/global';
import { ButtonBase } from 'components/Button/styles';
interface ITrProps {
  intervaloeleicao?: number;
  separador?: boolean;
}
export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;


  >header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    div{
      display: flex;
      align-items: center;
      min-width: 250px;
      width: 100%;
    }
    h4{
      min-width: 130px;
    }
    >button{
      width:180px;
    align-items: normal;
    }
  }
`;

export const Header = styled.div`
  flex-grow: auto;
  display: flex;
  padding-bottom: 10px;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  ${ButtonBase} {
    margin: 0 10px 0 0 !important;
    min-width: 170px !important;
  }
`;

export const TableLinhaRoteiro = styled.table`
  caret-color: transparent;
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        padding: 10px 0px;

        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};

        button {
          margin: 0;
        }
      }
    }
  }
`;

export const Table = styled(GlobalTable)`
  th {
    &:nth-of-type(2),
    &:nth-of-type(3) {
      width: 170px; // Flags
    }
    &:nth-of-type(4),
    &:nth-of-type(5) {
      width: 210px; // Datas
    }
    &:nth-of-type(6) {
      width: 120px; // Ações
    }
    &:not(:nth-of-type(1)) {
      text-align: center;
    }
  }
  td {
    &:nth-of-type(2),
    &:nth-of-type(3) {
      > div {
        margin: 0 auto; // Flags
      }
    }
    &:nth-of-type(4),
    &:nth-of-type(5) {
      text-align: center; // Datas
    }
    &:nth-of-type(6) {
      display: flex; // Ações
      justify-content: flex-end;
      > div {
        margin: 0; // Removendo margin do DropDownMenu
      }
    }
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  > div {
    margin-right: 10px;
  }
`;

export const Tr = styled.tr<ITrProps>`
  background-color: ${props =>
    props.intervaloeleicao === 1
      ? props.theme.daytime.manha
      : props.intervaloeleicao === 2
      ? props.theme.daytime.tarde
      : props.intervaloeleicao === 3
      ? props.theme.daytime.noite
      : props.separador
      ? darken(0.03, props.theme.cardBackgroud)
      : lighten(0.03, props.theme.cardBackgroud)};
  &:hover {
    background-image: linear-gradient(
      ${props => props.theme.cardBackgroud},
      ${props => transparentize(0.5, props.theme.info)}
    );
  }
`;
